import { Seo } from "@/components/Seo";
import { StructuredData } from "@/components/StructuredData";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ServicePrograms } from "@/components/ServicePrograms";
import { ProblemSection } from "@/components/ProblemSection";
import { ServicesSection } from "@/components/ServicesSection";
import { ResidentialSection } from "@/components/ResidentialSection";
import { B2BValueSection } from "@/components/B2BValueSection";
import { IndustriesSection } from "@/components/IndustriesSection";
import { PreventiveMaintenanceSection } from "@/components/PreventiveMaintenanceSection";
import { MaintenanceContractSection } from "@/components/MaintenanceContractSection";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Marquee } from "@/components/Marquee";
import { ProcessSection } from "@/components/ProcessSection";
import { PortfolioSection } from "@/components/PortfolioSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { LeadForm } from "@/components/LeadForm";
import { FAQSection } from "@/components/FAQSection";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

export default function LandingPage() {
  return (
    <>
      <Seo canonical="/" />
      <StructuredData />
      <Navbar />
      <main>
        <Hero />
        <ServicePrograms />
        <ProblemSection />
        <ServicesSection />
        <ResidentialSection />
        <B2BValueSection />
        <IndustriesSection />
        <PreventiveMaintenanceSection />
        <MaintenanceContractSection />
        <WhyChooseUs />
        <Marquee />
        <ProcessSection />
        <PortfolioSection />
        <TestimonialsSection />
        <LeadForm />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}
